import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { trackPage } from "./analytics";

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPage(location.pathname + location.search);
  }, [location]);

  return null;
};

export default AnalyticsTracker;
